/* V2 - Resizable Video Screen */

import * as React from "react";
import {connect} from "react-redux";
import VideoCallContainer from "./VideoCallContainer";


interface ResizableVideoOverlayContainerProps {
    videoRoomName: string;
    userIdentity: string;
    accessToken: string;
    isExpanded: boolean;
}


interface ResizableVideoOverlayContainerState {
    isExpanded: boolean
}

class ResizableVideoOverlayContainer extends React.Component<ResizableVideoOverlayContainerProps, ResizableVideoOverlayContainerState> {
    render() {
        let outerVideoContainerClasses = "outer-video-container " + (this.props.isExpanded ? "expanded-outer-video-container" : "collapsed-outer-video-container");

        return (
            <div className={outerVideoContainerClasses}>
                {/*<div className="video-resize-button" onClick={this.onResizeButtonClicked}>*/}
                    {/*{this.state.isExpanded &&*/}
                    {/*<img style={{height: "100%", width: "100%"}}*/}
                         {/*src="/images/icons/call_dashboard_icons/resize-to-small.png"/>*/}
                    {/*}*/}

                    {/*{!this.state.isExpanded &&*/}
                    {/*<img style={{height: "100%", width: "100%"}}*/}
                         {/*src="/images/icons/call_dashboard_icons/resize-to-big.png"/>*/}
                    {/*}*/}

                {/*</div>*/}
                <VideoCallContainer
                    onLeaveRoom={this.onDisconnected}
                    completeConsultationButtonClicked={this.completeConsultationButtonClicked}
                    videoCallRoomName={this.props.videoRoomName}
                    userIdentity={this.props.userIdentity}
                    isExpanded={this.props.isExpanded}
                    communicationAccessToken={this.props.accessToken}/>
            </div>
        )
    }
};


function mapStateToProps(state: any, ownProps: any): any {
    return {};
}

function mapDispatchToProps(dispatch: any): any {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ResizableVideoOverlayContainer);
